import classNames from 'classnames';
import Link from 'next/link';
import { useIntl } from 'react-intl';

import { PagesWithTabs } from '@/types';
import { LibraryTabs } from '@/types/library';

interface ButtonsTabsProps {
  pageAssociated: keyof typeof PagesWithTabs;
  buttons: { link: string; prefetch?: boolean | null }[];
  activeButton: keyof typeof LibraryTabs;
}

export const ButtonsTabs = ({ pageAssociated, buttons, activeButton }: ButtonsTabsProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className="px-5">
      <ul role="tablist" className="tab-list">
        {buttons.map(({ link, prefetch = null }, index) => (
          <li key={link}>
            <Link
              href={`/${pageAssociated}/${link}`}
              className={classNames({
                selected: activeButton === link,
              })}
              aria-selected={activeButton === link}
              aria-controls={`tabpanel-${index + 1}`}
              role="tab"
              prefetch={prefetch}
            >
              {formatMessage({ id: `${pageAssociated}.tabs.${link}` })}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
